import { PluginType } from '@deephaven/plugin';
import { vsGraph } from '@deephaven/icons';
import { ChartWidgetPlugin } from "./ChartWidgetPlugin.js";
import { ChartPanelPlugin } from "./ChartPanelPlugin.js";
var ChartPluginConfig = {
  name: 'ChartPanel',
  title: 'Chart',
  type: PluginType.WIDGET_PLUGIN,
  component: ChartWidgetPlugin,
  panelComponent: ChartPanelPlugin,
  supportedTypes: 'Figure',
  icon: vsGraph
};
export default ChartPluginConfig;
//# sourceMappingURL=ChartPluginConfig.js.map